import React from "react";
import {useTranslation} from "react-i18next";
import {Image} from "react-bootstrap";
import generatorImg from "../../../assets/img/how-to-generate-a-spf-record.webp";
import {routes} from "../../../routes";
import {I18nService} from "../../../service/i18nService";

export const RecordGeneratorSummary = () => {
    const {t} = useTranslation();
    const i18nService = new I18nService();
    const currentLang = i18nService.getLanguage();

    return (
        <section
            className="row align-items-center gy-5 mt-5 ps-4 pe-4 pb-5"
            aria-labelledby="dmarc-generator"
        >
            <div className="col-12 col-lg-6 order-2 order-lg-1 text-lg-end">
                <h2 id="dmarc-generator" className="fw-bold mb-3">
                    {t("pages.home.pageSections.generator.title")}
                </h2>
                <h3 className="h5 text-muted mb-3">{t("pages.home.pageSections.generator.sub")}</h3>
                <p className="lead">{t("pages.home.pageSections.generator.description")}</p>
                <ul className="list-unstyled mt-3">
                    <li>{t("pages.home.pageSections.generator.list.one")}</li>
                    <li>{t("pages.home.pageSections.generator.list.two")}</li>
                    <li>{t("pages.home.pageSections.generator.list.three")}</li>
                </ul>
                <a
                    href={`${currentLang}/${routes["dmarcRecordGenerator"][currentLang]}`}
                    className="btn btn-info text-white btn-lg mt-4">
                    {t("pages.home.pageSections.generator.cta")}
                </a>
            </div>
            <div className="col-12 col-lg-6 order-1 order-lg-2 text-center text-lg-end">
                <Image
                    src={generatorImg}
                    alt={t("pages.home.pageSections.generator.imageAlt")}
                    fluid
                    className="rounded shadow w-100 w-lg-75"
                    loading={"lazy"}
                />
            </div>
        </section>
    );
};
